import React, { useEffect } from "react";
import { Field, Form, Formik } from "formik";
import {
  CheckBox,
  GalleryField,
  TextField,
  Select,
  Loading,
  TextArea,
} from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import Modal from "components/Modal";
import { useCore } from "store/core";
import axios from "axios";
import * as Icons from "react-feather";

const displayLocations = [
  { label: "Sidebar", value: "Sidebar" },
  { label: "Carousel", value: "Carousel" },
  { label: "Split", value: "Split" },
];

const types = [
  { label: "همه", value: "all" },
  { label: "خبر", value: "news" },
  { label: "ویدیو", value: "video" },
];

const EditSlide = (props) => {
  const { show, close, submit, item, setSlides, slides } = props;

  const core = useCore();

  return (
    <Modal show={show} title="ویرایش صفحه" handleClose={close}>
      <Formik
        initialValues={item}
        onSubmit={(values) => {
          // فقط اسلاید مورد نظر را به‌روزرسانی کنید
          const updatedSlides = slides?.map((slide) =>
            slide?.id === item?.id ? { ...slide, ...values } : slide
          );

          // فراخوانی submit برای انجام عملیات بعدی
          submit(values);

          // به‌روزرسانی لیست اسلایدها
          setSlides(updatedSlides);

          // بستن مدل
          close();
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty, values, setFieldValue }) => (
          <Form>
            <div className="box rounded py-3">
              <div className="p-3 justify-aroundintro-x">
                <div className="col-span-2 md:grid md:grid-cols-2 md:gap-2">
                  <Field
                    placeholder="نام"
                    label="نام:"
                    name="faTitle"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام(en) :"
                    name="enTitle"
                    component={TextField}
                  />

                  <Field
                    label="نوع دیتا:"
                    name="type"
                    component={Select}
                    options={types}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    placeholder="آیکون"
                    label="آیکون :"
                    name="icon"
                    component={TextField}
                  />

                  <Field
                    label="ترتیب نمایش"
                    name="displayPriority"
                    component={TextField}
                    type="number"
                    validate={(value) => validationWrapper(value, number)}
                  />
                  <Field
                    label="تعداد نمایش"
                    name="count"
                    component={TextField}
                    type="number"
                    validate={(value) => validationWrapper(value, number)}
                  />
                  <div className="intro-y">
                    <Field
                      label=":دسته بندی"
                      name="category"
                      component={Select}
                      options={core.categories || []}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <Field
                    label="محل نمایش:"
                    name="displayLocation"
                    component={Select}
                    options={displayLocations}
                    className="w-full px-3 py-2 border rounded"
                  />
                  <div className={"col-span-2"}>
                    <Field
                      label="مدیا"
                      name="media"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <button className="btn btn-sm btn-primary mt-10" type="submit">
                  ویرایش صفحه
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditSlide;
